import apiClient from '@/utils/request'
import { IGeneralResponse } from '@/api/types'
import { nestedQueryFormatter } from '@/utils/query'

export interface INotificationAttributes {
  id: number
  content: string
  published: boolean
}

export interface INotification {
  id: string
  type: 'message'
  attributes: INotificationAttributes
}

export interface INotificationResponse extends IGeneralResponse {
  data: Array<INotification>
}

export const fetchItems = async (): Promise<INotificationResponse> => {
  const params = Object.assign(
    { limit: 1 },
    nestedQueryFormatter('sorter', { direction: 'desc', field: 'created_at' })
  )
  const response = await apiClient.get<INotificationResponse>(
    '/notifications',
    { params }
  )
  return response.data
}

export const updateItem = async (
  params: INotificationAttributes
): Promise<INotificationResponse> => {
  const response = await apiClient.put<INotificationResponse>(
    `/notifications/${params.id}`,
    params
  )
  return response.data
}
